import { create } from "zustand";

export const useStore = create((set) => ({
  id: null,
  location: null,
  setId: (newId) => set({ id: newId }),
  setLocation: (newLocation) => set({ location: newLocation }),
}));

export const store = useStore;


